import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

/**
 * App Links verificados (ticket-car-app 1.3.0): o Android abre o app direto em
 * https://ticketcar.com.br/app/... (PRD) e .../app-dev/... (DEV). Aqui traduzimos o link numa rota do app.
 *   /app/oficina/<id>   → /oficinas/<id>
 *   /app/entrar?c=...   → /entrar?c=...   (volta do login com Google/Apple)
 * No iPhone também chega ticketcar:///app/... (esquema do app: plano B quando o Universal Link não abre o app).
 */
export function routeFor(url) {
  let path;
  let query;
  try {
    const u = new URL(url);
    // ticketcar://app/entrar → host "app"; ticketcar:///app/entrar → host vazio
    path = u.protocol === 'ticketcar:' ? `${u.host ? `/${u.host}` : ''}${u.pathname}` : u.pathname;
    query = u.search;
  } catch {
    return null;
  }
  const m = path.match(/^\/app(?:-dev)?\/(.*)$/);
  if (!m) return null;
  const shop = m[1].match(/^oficina\/([A-Za-z0-9]{1,40})\/?$/);
  if (shop) return `/oficinas/${shop[1]}`;
  if (/^entrar\/?$/.test(m[1])) {
    const q = new URLSearchParams(query);
    const keep = new URLSearchParams();
    for (const k of ['c', 'erro']) if (q.get(k)) keep.set(k, q.get(k).slice(0, 100));
    return `/entrar?${keep}`;
  }
  return null;
}

export const appLinks = {
  configure({ open }) {
    if (!Capacitor.isNativePlatform()) return;
    App.addListener('appUrlOpen', ({ url }) => {
      const route = routeFor(url);
      if (route) open(route);
    }).catch(() => {});
  },
};
